import styled from 'styled-components';

import { CustomOperationContainer } from 'components/Feature/Operations/styles';

export default styled.div`
  margin: 32px 0;

  ${CustomOperationContainer} {
    justify-content: space-between;
    gap: 0.4rem;
  }
`;
